"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHostByScope = void 0;
const types_1 = require("../types");
const getHostByScope = ({ domain, scope }) => {
    const baseDomain = 'messages-hub-realestates';
    if (!domain) {
        return '';
    }
    if (!scope || scope === types_1.ScopesE.PROD) {
        return `https://${baseDomain}.${domain}`;
    }
    if (scope === types_1.ScopesE.LOCAL) {
        return `https://dev.${domain}:8446`;
    }
    // return `https://${baseDomain}${`-${scope}`}.${domain}`;
    return `https://${baseDomain}.${domain}`;
};
exports.getHostByScope = getHostByScope;
